<template>
  <div class="page">
    <LoadingSpinner v-if="processing" id="loading-spinner" />
    <div id="action-bar">
      <div id="page-title">
        <template v-if="client">
          {{ client.name }} ({{ client.internalId }})</template
        >
      </div>
      <div>
        <SectionToggle :sections="views" v-model="currentView" />
      </div>
    </div>
    <SingleTest
      v-for="(test, index) in completedTests"
      :key="'result-' + index"
      :test="test"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import TestStatus from "@/components/TestStatus";
import LoadingSpinner from "@/components/LoadingSpinner";
import SingleTest from "./SingleTest";
import SectionToggle from "@/components/SectionToggle";

export default {
  name: "Tests",
  data() {
    return {
      query: "",
      statusFilter: null,
      tests: [],
      client: null,
      processing: false,
      currentView: "overview",
      views: [
        {
          title: "Overview",
          id: "overview",
          icon: "stream"
        },
        {
          title: "Timeline",
          id: "timeline",
          icon: "chart-line"
        },
        {
          title: "Export",
          id: "export",
          icon: "file-download"
        }
      ]
    };
  },
  props: {
    clientId: {
      type: String,
      required: true
    }
  },
  components: {
    TestStatus,
    LoadingSpinner,
    SingleTest,
    SectionToggle
  },
  methods: {},
  computed: {
    completedTests() {
      return this.tests.filter(test => test.status === "completed");
    },
    benchmarks() {
      return this.$store.getters["TestsStore/benchmarks"];
    }
  },
  async mounted() {
    this.processing = true;
    if (!this.benchmarks)
      await this.$store.dispatch("TestsStore/getBenchmarks");
    this.client = await this.$store.dispatch("ClientsStore/get", this.clientId);
    this.tests = await this.$store.dispatch(
      "TestsStore/getByClient",
      this.clientId
    );
    this.tests = this.tests.sort((a, b) => b.created - a.created);
    this.processing = false;
  },
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
@import "../../styles/vars";

.page {
  background-color: #f5f5f5;
  min-height: 100vh;
}
</style>
